import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const LinkIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M11,17H7A5,5,0,0,1,7,7h4V9H7a3,3,0,0,0,0,6h4ZM17,7H13V9h4a3,3,0,0,1,0,6H13v2h4A5,5,0,0,0,17,7Zm-1,4H8v2h8Z' />
    </svg>
  )
}
